import React from 'react'
import { Link } from 'react-router-dom'
import { X } from 'lucide-react'
import { clsx } from 'clsx'

function Sidebar({ navigation, sidebarOpen, setSidebarOpen, currentPath }) {
  return (
    <>
      {/* Mobile sidebar overlay */}
      {sidebarOpen && (
        <div className="fixed inset-0 z-40 lg:hidden">
          <div className="fixed inset-0 bg-secondary-900/80" onClick={() => setSidebarOpen(false)} />
          <div className="relative flex w-full max-w-xs flex-1">
            <div className="absolute right-0 top-0 -mr-12 pt-2">
              <button
                type="button"
                className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                onClick={() => setSidebarOpen(false)}
              >
                <span className="sr-only">Close sidebar</span>
                <X className="h-6 w-6 text-white" aria-hidden="true" />
              </button>
            </div>
            <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-4">
              <div className="flex h-16 shrink-0 items-center">
                <div className="flex items-center">
                  <div className="h-8 w-8 bg-primary-600 rounded-lg flex items-center justify-center">
                    <span className="text-white font-bold text-lg">T</span>
                  </div>
                  <span className="ml-2 text-xl font-bold text-secondary-900">
                    Tailor ERP
                  </span>
                </div>
              </div>
              <nav className="flex flex-1 flex-col">
                <ul role="list" className="flex flex-1 flex-col gap-y-7">
                  <li>
                    <NavigationItems items={navigation} currentPath={currentPath} />
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      )}

      {/* Static sidebar for desktop */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col">
        <div className="flex grow flex-col gap-y-5 overflow-y-auto border-r border-secondary-200 bg-white px-6 pb-4">
          <div className="flex h-16 shrink-0 items-center">
            <div className="flex items-center">
              <div className="h-8 w-8 bg-primary-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">T</span>
              </div>
              <span className="ml-2 text-xl font-bold text-secondary-900">
                Tailor ERP
              </span>
            </div>
          </div>
          <nav className="flex flex-1 flex-col">
            <ul role="list" className="flex flex-1 flex-col gap-y-7">
              <li>
                <NavigationItems items={navigation} currentPath={currentPath} />
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  )
}

function NavigationItems({ items, currentPath }) {
  return (
    <ul role="list" className="-mx-2 space-y-1">
      {items.map((item) => (
        <li key={item.name}>
          <NavigationItem item={item} currentPath={currentPath} />
        </li>
      ))}
    </ul>
  )
}


function NavigationItem({ item, currentPath }) {
  const isActive = currentPath === item.href

  return (
    <Link
      to={item.href}
      className={clsx(
        'group flex gap-x-3 rounded-md p-2 text-base leading-6 font-semibold',
        isActive
          ? 'bg-primary-100 text-primary-700'
          : 'text-secondary-700 hover:bg-secondary-100 hover:text-secondary-900'
      )}
    >
      {item.icon && (
        <item.icon
          className={clsx(
            'h-6 w-6 shrink-0',
            isActive ? 'text-primary-700' : 'text-secondary-400 group-hover:text-secondary-500'
          )}
          aria-hidden="true"
        />
      )}
      {item.name}
    </Link>
  )
}

export default Sidebar